module.exports = __webpack_public_path__ + "img/skin.c35a2eac.svg";